export default __webpack_public_path__ + "static/media/uploader-oneTouchVerioIQ-problem-1.00f4a804.png";